var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouritesstaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4000_178864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4854 17.0584C11.8021 16.8683 12.1979 16.8683 12.5146 17.0584L16.3848 19.381L15.3597 15.0125C15.2745 14.6497 15.3982 14.2696 15.6806 14.0264L19.0813 11.097L14.6014 10.7193C14.2323 10.6882 13.9107 10.4557 13.7655 10.115L12 5.97276L10.2345 10.115C10.0893 10.4557 9.76766 10.6882 9.3986 10.7193L4.9187 11.097L8.31942 14.0264C8.60177 14.2696 8.72545 14.6497 8.64032 15.0125L7.61523 19.381L11.4854 17.0584ZM11.0415 3.63079C11.4006 2.78974 12.5994 2.78974 12.9585 3.63079L15.2325 8.96616L21.0458 9.45619C21.963 9.5332 22.3352 10.6703 21.6392 11.2693L17.2229 15.0736L18.5495 20.727C18.7587 21.618 17.7861 22.3211 16.9976 21.848L12 18.8488L7.00238 21.848C6.21387 22.3211 5.2413 21.618 5.4505 20.727L6.77709 15.0736L2.36081 11.2693C1.66482 10.6703 2.03695 9.5332 2.9542 9.45619L8.76749 8.96616L11.0415 3.63079Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4000_178864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesstaricon);
export default __webpack_public_path__ + "static/media/Favourites star icon.7d731ff1378114a8b514fcf44cd72854.svg";
export { ForwardRef as ReactComponent };